/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const PointingHand = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 17 20">
      <path
        d="M4.80111 1.5C4.80111 0.67125 5.47236 0 6.30111 0C7.12986 0 7.80111 0.67125 7.80111 1.5V7.0575C8.11986 6.7725 8.53986 6.6 9.00111 6.6C9.77361 6.6 10.4336 7.0875 10.6886 7.77C11.0186 7.42125 11.4836 7.2 12.0011 7.2C12.9499 7.2 13.7261 7.93125 13.7974 8.86125C14.1161 8.5725 14.5399 8.4 15.0011 8.4C15.9949 8.4 16.8011 9.20625 16.8011 10.2V14.4C16.8011 17.0513 14.6524 19.2 12.0011 19.2H8.80236C8.61486 19.2 8.43111 19.1888 8.25111 19.1625C6.17736 18.9525 4.26861 17.8875 3.00111 16.2L0.301113 12.6C-0.197637 11.9363 -0.0626373 10.9988 0.601113 10.5C1.26486 10.0013 2.20236 10.1363 2.70111 10.8L4.80111 13.6013V1.5ZM9.00111 11.4C9.00111 11.07 8.73111 10.8 8.40111 10.8C8.07111 10.8 7.80111 11.07 7.80111 11.4V15C7.80111 15.33 8.07111 15.6 8.40111 15.6C8.73111 15.6 9.00111 15.33 9.00111 15V11.4ZM10.8011 10.8C10.4711 10.8 10.2011 11.07 10.2011 11.4V15C10.2011 15.33 10.4711 15.6 10.8011 15.6C11.1311 15.6 11.4011 15.33 11.4011 15V11.4C11.4011 11.07 11.1311 10.8 10.8011 10.8ZM13.8011 11.4C13.8011 11.07 13.5311 10.8 13.2011 10.8C12.8711 10.8 12.6011 11.07 12.6011 11.4V15C12.6011 15.33 12.8711 15.6 13.2011 15.6C13.5311 15.6 13.8011 15.33 13.8011 15V11.4Z"
        fill="#000"
      />
    </BaseSvgIcon>
  )
}

export default PointingHand
